export default __webpack_public_path__ + "static/media/romania.c1cde91e.svg";